import React from "react"

import {LoadingIndicator} from "~/components/"
import {useApi} from "~/hooks/"

export const withUserFeedback = (render, data) => {
  if (data.some(data => data === useApi.LOADING)) {
    return <LoadingIndicator />
  } else if (data.some(data => data === useApi.ERROR)) {
    return <p>Es ist ein Fehler aufgetreten.</p>
  } else {
    return render()
  }
}



// WEBPACK FOOTER //
// ./src/helpers/index.js